/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1400",
  xxw: "1400",
  xxxw: "1400"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line--added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line--added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
    })
  );
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

const plyrsPageheaderVideo = function () {
  const plyrs = document.querySelectorAll(".pageheader--video .mediavideo");

  if (!plyrs) {
    return;
  }

  const controls = `
			<div class="plyr__controls">
					<button type="button" class="plyr__control" aria-label="Play, {title}" data-plyr="play">
						<div class="icon--pressed" role="presentation">
						<i class="fas fa--left fa-pause"></i> Pause
						</div>
						<div class="icon--not-pressed" role="presentation">
						<i class="fas fa--left fa-play"></i> Play
						</div>
						<span class="label--pressed plyr__tooltip" role="tooltip">Pause</span>
						<span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span>
					</button>
					<button type="button" class="plyr__control" aria-label="Mute" data-plyr="mute">
							<div class="icon--pressed" role="presentation">
							<i class="fas fa--left fa-volume-slash"></i> Mute
							</div>
							<div class="icon--not-pressed" role="presentation">
							<i class="fas fa--left fa-volume"></i>Unmute
							</div>
							<span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span>
							<span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span>
					</button>
			</div>
			`;

  plyrs.forEach(function (el) {
    let plyr = el.querySelector(".mediavideo__video");
    let player = new Plyr(plyr, {
      controls,
      media: {
        loop: true
      },
      autoplay: el.classList.contains("mediavideo--autoplay")
    });

    el.player = player;
    el.player.play();
    el.player.muted = true;
  });
}; // plyrsPageheaderVideo();

plyrsPageheaderVideo();

const plyrsInit = function () {
  const plyrs = document.querySelectorAll(".module--video .mediavideo:not(.mediavideo--autoplay)");

  if (!plyrs) {
    return;
  }
  const controls = `
	<div class="plyr__controls">
			<button type="button" class="plyr__control" aria-label="Play, {title}" data-plyr="play">
			<div class="icon--pressed" role="presentation">
			<i class="fas fa--left fa-pause"></i> Pause
			</div>
			<div class="icon--not-pressed" role="presentation">
			<i class="fas fa--left fa-play"></i> Play
			</div>
				<span class="label--pressed plyr__tooltip" role="tooltip">Pause</span>
				<span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span>
			</button>
			<button type="button" class="plyr__control" aria-label="Mute" data-plyr="mute">
					<div class="icon--pressed" role="presentation">
					<i class="fas fa--left fa-volume-slash"></i> Mute
					</div>
					<div class="icon--not-pressed" role="presentation">
					<i class="fas fa--left fa-volume"></i>Unmute
					</div>
					<span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span>
					<span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span>
			</button>
	</div>
	`;

  plyrs.forEach(function (el) {
    let moduleVideo = el.closest(".module--video");
    let plyr = el.querySelector(".mediavideo__video");

    let player = new Plyr(plyr, {
      controls,
      media: {
        loop: true
      }
    });

    el.player = player;
    plyr.addEventListener("mouseenter", function () {
      moduleVideo.classList.add("module--video--playing");
      el.player.play();
      el.player.muted = true;
    });
    plyr.addEventListener("mouseleave", function () {
      moduleVideo.classList.remove("module--video--playing");
      el.player.muted = true;
      el.player.pause();
    });
  });
}; // plyrsInit();

plyrsInit();

const plyrsInitAutoplay = function () {
  const plyrs = document.querySelectorAll(".module--video .mediavideo--autoplay");

  if (!plyrs) {
    return;
  }
  const controls = `
	<div class="plyr__controls">
			<button type="button" class="plyr__control" aria-label="Play, {title}" data-plyr="play">
				<div class="icon--pressed" role="presentation">
				<i class="fas fa--left fa-pause"></i> Pause
				</div>
				<div class="icon--not-pressed" role="presentation">
				<i class="fas fa--left fa-play"></i> Play
				</div>
				<span class="label--pressed plyr__tooltip" role="tooltip">Pause</span>
				<span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span>
			</button>
			<button type="button" class="plyr__control" aria-label="Mute" data-plyr="mute">
					<div class="icon--pressed" role="presentation">
					<i class="fas fa--left fa-volume-slash"></i> Mute
					</div>
					<div class="icon--not-pressed" role="presentation">
					<i class="fas fa--left fa-volume"></i>Unmute
					</div>
					<span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span>
					<span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span>
			</button>
	</div>
	`;

  plyrs.forEach(function (el) {
    let plyr = el.querySelector(".mediavideo__video");
    let moduleVideo = el.closest(".module--video");
    let player = new Plyr(plyr, {
      controls,
      media: {
        loop: true
      },
      autoplay: true,
      clickToPlay: false
    });

    el.player = player;
    el.player.play();
    el.player.muted = true;

    plyr.addEventListener("mouseenter", function () {
      moduleVideo.classList.add("module--video--playing");
    });
    plyr.addEventListener("mouseleave", function () {
      moduleVideo.classList.remove("module--video--playing");
    });
  });
}; // plyrsInitAutoplay();

plyrsInitAutoplay();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

$("[data-fancybox]").fancybox({
  afterShow: function () {
    body.classList.remove("mobnavopen");
  }
});

/* Person pop up */
$(".person__link").fancybox({
  baseClass: "person__popup",
  afterLoad: function (instance, slide) {
    // Re-init Lazy load
    lazyLoadInstance.update();
  }
});

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPosts = function () {
  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.classList.add("paging__loadmore--loading");
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        button.classList.remove("paging__loadmore--loading");
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts
        php_variables.current_page++;
        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.remove();
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        effectsInit();
      } else {
        button.remove(); // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();
loadmoreInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function () {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "90%"
    });
  });
}; // effectsInit();
effectsInit();

/*  ==========================================================================
    Sitefooter animation
    ========================================================================== */
const sitefooterAnimate = document.querySelector(".sitefooter__animate");
const sitefooterAnimateSvg = document.querySelectorAll(".sitefooter__animatesvgpath");

const sitefooterAnimateInit = function () {
  if (!sitefooterAnimate) {
    return;
  }

  const waypoints = new Waypoint({
    element: sitefooterAnimate,
    handler: function (direction) {
      if (direction === "down") {
        sitefooterAnimateSvg.forEach(function (val) {
          val.classList.add("effect--ready");
        });
      } else {
        sitefooterAnimateSvg.forEach(function (val) {
          val.classList.remove("effect--ready");
        });
      }
    },
    offset: "99%"
  });
}; // sitefooterAnimateInit();
sitefooterAnimateInit();

/*  ==========================================================================
    Our Process Pinned Horizontal Scroll
    ========================================================================== */

const horizontalScroll = document.querySelector(".our-process__wrapper-inner");

const ourProcessHorizontalScroll = function () {
  if (!horizontalScroll) {
    return;
  }
  gsap.registerPlugin(ScrollTrigger);

  let module__process = horizontalScroll.closest(".our-process__wrapper-outer");
  let sections = gsap.utils.toArray(".our-process__wrapper-inner"),
    currentSection = sections[0];

  gsap.defaults({ overwrite: "auto", duration: 1.3 });

  // create a ScrollTrigger for each section
  sections.forEach((section, i) => {
    ScrollTrigger.create({
      // use dynamic scroll positions based on the window height (offset by half to make it feel natural)
      trigger: ".our-process__wrapper-outer-pin",
      pin: ".module--our-process",
      start: self => (i === 0 ? "top top" : self.previous().end),
      end: () => "+=" + innerHeight,
      scrub: true,
      // markers: true,
      toggleActions: "restart none reverse reset",
      // when a new section activates (from either direction), set the section accordingly.
      onToggle: self => self.isActive && setSection(section, i)
    });
  });

  function setSection(newSection, i) {
    $(module__process).attr("class", "our-process__wrapper-outer our-process__wrapper-outer--" + i);
    $(".stepper-nav__steps").removeClass("stepper-nav__steps--active");
    $(".stepper-nav__steps--" + i).addClass("stepper-nav__steps--active");

    Waypoint.refreshAll();
    if (newSection !== currentSection) {
      gsap.to(currentSection, { autoAlpha: 0, duration: 0.8 });
      gsap.to(newSection, { autoAlpha: 1, duration: 0.8 });
      currentSection = newSection;
    }
  }
};

setTimeout(function () {
  ourProcessHorizontalScroll();
  // As this module is after the horizontal scroll we want to re init to prevent height change.
  interactiveCarouselInit(interactiveCarousels);
}, 1000);

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel:not(.timeline) .owl-carousel:not(.spotlight-carousel)");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    let responsiveArray = "";
    if (elem.classList.contains("quote--carousel")) {
      responsiveArray = carouselResponsiveArray(elem, true);
    } else {
      responsiveArray = carouselResponsiveArray(elem);
    }

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoheight && elem.dataset.autoheight === "disable" ? false : true;
    const dotsData = elem.dataset.dotsdata ? elem.dataset.dotsdata : false;
    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      dotsData: dotsData,
      items: 1,
      navText: ["<i class='fas fa-chevron-left'></i>", "<i class='fas fa-chevron-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight
    });

    $(elem).on("changed.owl.carousel", function (e) {
      if ($(elem).hasClass("featured-films--carousel")) {
        var slides = e.relatedTarget;

        var url = $(elem).find(".owl-item .row--column").eq(slides.current()).data("url");

        $(".learn-more").attr("href", url);
      }

      lazyLoadInstance.update(); // reinit lazy load after clones
    });

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem, custom = false) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }

      if (custom && classWidth === 0) {
        responsiveArray[classWidth] = {
          stagePadding: 30,
          items: numItems
        };
      } else {
        responsiveArray[classWidth] = {
          items: numItems
        };
      }
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
			Interactive Quote Carousel
			========================================================================== */
var executed = false;
const interactiveCarousels = document.querySelectorAll(".module--interactive-carousel .owl-carousel");

const interactiveCarouselInit = function (interactiveCarousels) {
  if (interactiveCarousels.length <= 0 && !executed) {
    return;
  }
  if (!executed) {
    executed = true;

    interactiveCarousels.forEach(elem => {
      const slides = elem.querySelectorAll(".col");
      if (!slides) {
        return;
      }
      // Scroll trigger to allow us to hijack the space bar to go between slides
      gsap.registerPlugin(ScrollTrigger);

      ScrollTrigger.create({
        trigger: elem,
        markers: false,
        start: "center 80%",
        end: "center 20%",
        scrub: 1,
        onEnter: () => {
          $(elem).addClass("space__overtake");
        },
        onLeave: () => {
          $(elem).removeClass("space__overtake");
        },
        onEnterBack: () => {
          $(elem).addClass("space__overtake");
        },
        onLeaveBack: () => {
          $(elem).removeClass("space__overtake");
        }
      });

      $(elem).owlCarousel({
        autoplay: false,
        loop: true,
        nav: false,
        dots: false,
        items: 1,
        navText: ["<i class='fas fa-chevron-left'></i>", "<i class='fas fa-chevron-right'></i>"],
        startPosition: slides.length,
        autoHeight: false,
        // animateOut: "slideOut",
        draggable: false,
        mouseDrag: false,
        touchDrag: false
      });
      /* jshint ignore:start */
      // Get all of the shuffle buttons
      let elements = elem.querySelectorAll(".slide__shuffle");
      for (var i = 0; i < elements.length; i++) {
        elements[i].addEventListener("click", function (event) {
          $(elem).trigger("next.owl.carousel");
        });
      }
      /* jshint ignore:end */
      var upHitOnce = false;
      // When space bar is tapped to move to the next slide.
      window.addEventListener("keydown", function (e) {
        if (e.keyCode === 32) {
          e.preventDefault();

          $(elem).trigger("next.owl.carousel");
        }
      });

      $(elem).on("resized.owl.carousel", function (event) {
        // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
        setTimeout(function () {
          Waypoint.refreshAll();
        }, 500);
      });
    });
  }
}; // interactiveCarouselInit();

interactiveCarouselInit(interactiveCarousels);
//

/*  ==========================================================================
		Timeline Carousel
			========================================================================== */

const timelineCarousels = document.querySelectorAll(".module--timeline .timeline--carousel");

const timelineCarouselInit = function (timelineCarousels) {
  if (timelineCarousels.length <= 0) {
    return;
  }

  timelineCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    let module__timeline = elem.closest(".module--timeline");

    const slideTotal = elem.dataset.total;

    $(elem)
      .owlCarousel({
        autoplay: false,
        loop: false,
        nav: true,
        dots: false,
        items: 1,
        navText: ["<i class='fas fa-chevron-left'></i>", "<i class='fas fa-chevron-right'></i>"],
        responsive: {
          0: {
            items: 1
          },
          700: {
            items: 2
          },
          1000: {
            items: 3
          }
        },
        startPosition: 0,
        autoHeight: false
      })
      .on("changed.owl.carousel", function (e) {
        var slides = e.relatedTarget;
      });

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });

    $(elem).on("initialized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // timelineCarouselInit();
timelineCarouselInit(timelineCarousels);

/*  ==========================================================================
		Spotlight Carousel
			========================================================================== */

const spotlightCarousel = document.querySelectorAll(".spotlight-carousel");

const spotlightCarouselInit = function (spotlightCarousel) {
  if (spotlightCarousel.length <= 0) {
    return;
  }

  spotlightCarousel.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem, false);

    $(elem).owlCarousel({
      nav: false,
      dots: true,
      items: 1,
      autoHeight: true,
      dotsContainer: ".spotlight-carousel__thumbnails",
      animateIn: "fadeIn",
      animateOut: "fadeOut",
      responsive: responsiveArray
    });

    // Move to the next slide when a thumbnail is clicked
    $(".spotlight-carousel__thumbnails").on("click", ".col", function (e) {
      $(elem).trigger("to.owl.carousel", [$(this).index(), 300]);
    });

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // spotlightCarouselInit();
spotlightCarouselInit(spotlightCarousel);

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();

    let mobnavHeight = 0;
    if (!body.classList.contains(mobnavOpenclass)) {
      // IT'S NOT OPEN...
      body.classList.add(mobnavOpenclass);
    } else {
      // IT'S OPEN...
      body.classList.remove(mobnavOpenclass);
    }
  });
}; // mobnavInit()
mobnavInit();

/*  ==========================================================================
      NAVIGATION - mobnav dropdowns
      ========================================================================== */

const mobnavLinks = document.querySelectorAll(".mobnav .sitenav__item--hasdropdown .sitenav__item__dropdownarrow");

const mobnavlinksInit = function () {
  if (!mobnavLinks) {
    return;
  }

  mobnavLinks.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      e.preventDefault();
      const mobnavTargetSection = e.target.closest(".sitenav__item");
      mobnavTargetSection.classList.toggle("sitenav__item--open");
    });
  });
}; // mobnavlinksInit();
mobnavlinksInit();

/*  ==========================================================================
    Scroll to anchor links - .pagenav, .readmore buttons 
    ========================================================================== */

const pagenavLinks = document.querySelectorAll(".scrolltolink");

const pagenavInnit = function () {
  if (!pagenavLinks) {
    return;
  }

  pagenavLinks.forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();

      const id = el.getAttribute("href");

      window.scroll({
        top: document.querySelector(id).offsetTop - 100,
        behavior: "smooth" // Smooth scrolling behavior
      });
    });
  });
};

pagenavInnit();


/*  ==========================================================================
    FILTERING - URL Parameter functions
    ========================================================================== */

/* UPDATE URL PARAMETERS */
function filters__update_url(filter_data, search_data) {
  var url_params = "";

  $.each(filter_data, function (key, value) {
    if (!$.isEmptyObject(value)) {
      if (url_params === "") {
        url_params = url_params + "?";
      } else {
        url_params = url_params + "&";
      }
      // Convert values to comma seperated string
      let values = Object.keys(value)
        .map(function (k) {
          return value[k];
        })
        .join(",");
      url_params = url_params + "filter_" + key + "=" + values;
    }
  });

  if (search_data) {
    if (url_params === "") {
      url_params = url_params + "?";
    } else {
      url_params = url_params + "&";
    }
    url_params = url_params + "search=" + search_data;
  }

  var page_url = window.location.href.split("?")[0];
  var new_url = page_url + url_params;

  if (history.pushState) {
    window.history.pushState({ path: new_url }, "", new_url);
  }
}

/*  ==========================================================================
			FILTERING - Filter posts
			========================================================================== */

// Get current filters data from form inputs
function filters__get_filter_data(form, filters) {
  let filter_data = {};
  $(filters).each(function () {
    filter_data[this.name] = {};
    $("input[type=checkbox][name=" + this.name + "]:checked").each(function (index) {
      filter_data[this.name][index] = $(this).val();
    });
    $("input[type=radio][name=" + this.name + "]:checked").each(function (index) {
      filter_data[this.name][index] = $(this).val();
    });
  });
  return filter_data;
}

function filters__get_filter_data_url() {
  let filter_taxonomy = {};

  var siteURL = window.location.search.substring(1);
  var siteURLVariables = siteURL.split("&");

  for (var i = 0; i < siteURLVariables.length; i++) {
    let siteURLParameter = siteURLVariables[i].split("filter_")[1];
    siteURLParameter = siteURLParameter.split("=");
    let filter_data_name = siteURLParameter[0];
    let filter_data_value = siteURLParameter[1];
    filter_taxonomy[filter_data_name] = {};
    filter_taxonomy[filter_data_name] = filter_data_value;
  }

  return filter_taxonomy;
}

// Setup styling classes on new filter
function filters__update_styling(filter_data) {
  // Reset styles
  $(".filters__fieldset__field").removeClass("filters__fieldset__field--active");

  // Reset tags
  $(".filters__tags").removeClass("filters__tags--active");
  $(".filters__activetags__tags").html("");

  $.each(filter_data, function (key, values) {
    if (!$.isEmptyObject(values)) {
      let filter_name = key;

      $.each(values, function (key, value) {
        // Make input field active
        let filter_input = $("input[name='" + filter_name + "'][value='" + value + "']").closest(
          ".filters__fieldset__field"
        );
        $(filter_input).addClass("filters__fieldset__field--active");
        // Show active tags
        $(".filters__tags").addClass("filters__tags--active");
        // Add tag
        let filter_input_name = $(filter_input).find(".filters__fieldset__field__label").html();
        $(".filters__activetags__tags").append(
          "<div class='filters__tag' data-name='" +
            filter_name +
            "' data-value='" +
            value +
            "'>" +
            filter_input_name +
            "</div>"
        );
      });
    }
  });
}

function filter__ajax__call(data) {
  $.ajax({
    url: php_variables.ajax_url,
    data: data, // form data
    dataType: "json", // this data type allows us to receive objects from the server
    type: "POST",
    beforeSend: function (xhr) {
      $(".filters").find("button").text("Filtering...");
    },
    success: function (data) {
      // when filter applied:
      // set the current page to 1
      php_variables.current_page = 1;

      // set the new query parameters
      php_variables.posts = data.posts;

      // set the new max page parameter
      php_variables.max_page = data.max_page;

      // change the button label back
      $(".filters").find("button").text("Apply filter");

      // insert the posts to the container
      $(".posts-container").html(data.content);

      // Re-init links to make sure linklines on newly loaded content still work
      linksInit();

      // Re-init lazy load
      lazyLoadInstance.update(); // reinit lazy load after clones

      // Re-init effects
      effectsInit();

      // hide load more button, if there are not enough posts for the second page
      if (data.max_page < 2) {
        $(".paging__loadmore").hide();
      } else {
        $(".paging__loadmore").show();
      }

      // Finish filtering
      $(".posts-container").removeClass("filtering");
    },
    error: function (data) {}
  });
}

function filters__filter_posts(clear = false) {
  // Get filters and search passed in to main.js via filters.php
  let filters = filter_settings.filters;
  let search = filter_settings.search;
  let filter_taxonomy = false;
  let filter_data = false;
  let search_data = false;

  if (search) {
    search_data = $(".filters__search input").val();
  }

  if (
    window.location.href.indexOf("?") > -1 &&
    !$(".filters__tags").hasClass("filters__tags--active") &&
    !search_data &&
    !clear
  ) {
    filter_taxonomy = filters__get_filter_data_url();
    // When taking the user straight to the taxonmy page
  } else {
    filter_data = filters__get_filter_data($(".filters"), filters);
  }

  if (filter_data || search_data) {
    // Update filter styling and tags
    filters__update_styling(filter_data);

    // Update url
    filters__update_url(filter_data, search_data);
    // If is initial load and there is active tags on search data then trigger ajax, if not initial load then trigger everytime
    if (
      (filters_initial_load && ($(".filters__tags").hasClass("filters__tags--active") || search_data)) ||
      !filters_initial_load
    ) {
      filters_initial_load = false;

      // Scroll to filtering system
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $(".filters-pin").offset().top
        },
        250
      );

      // Start filtering
      $(".posts-container").addClass("filtering");

      // Trigger ajax
      var data = {
        action: "filter",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
        page: php_variables.current_page,
        filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
        filter_data: filter_data,
        search_data: search_data
      };

      filter__ajax__call(data);
    }
  } else if (filter_taxonomy) {
    // Scroll to filtering system
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $(".filters-pin").offset().top
      },
      250
    );

    // Start filtering
    $(".posts-container").addClass("filtering");

    // Trigger ajax
    var taxonomy_data = {
      action: "filter",
      query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
      page: php_variables.current_page,
      filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
      filter_data: filter_taxonomy
    };

    filter__ajax__call(taxonomy_data);
  }
}

// Setup an trigger filtering
let filters_initial_load = true;

if ($(".filters:not(.filters--search)").length) {
  // Filter on page load
  filters__filter_posts();

  // Filter on submit
  $(".filters").submit(function (e) {
    filters__filter_posts();

    // do not submit the form
    return false;
  });

  // Submit for on checkbox click
  $(".filters").on("change", "input:checkbox, input:radio", function () {
    // Show active tags
    $(".filters__tags").addClass("filters__tags--active");

    // Update filtering
    $(".filters").submit();
  });

  // Search open & close
  $(".filters__search__icon").click(function () {
    $(this).closest("form").submit();
  });

  // Remove tags on click
  $(".filters__activetags__tags").on("click", ".filters__tag", function () {
    let filter_name = $(this).data("name");
    let filter_value = $(this).data("value");
    // Unselect input checkbox
    let filter_input = $("input[name='" + filter_name + "'][value='" + filter_value + "']").prop("checked", false);
    // Remove tag
    $(this).remove();

    // Trigger filter
    filters__filter_posts();
  });

  // Filters Mobile
  window.addEventListener("resize", function () {
    if ($(window).width() <= gridSizes.md) {
      filters__mobile();
    }
  });

  if ($(window).width() <= gridSizes.md) {
    filters__mobile();
  }

  // Clear all
  $(".filters__clearall").click(function () {
    // Clear search
    $(".filters__search").find("input").val("");
    $(".filters__search").removeClass("filters__search--open");
    // Remove all tags
    $(".filters__tags").removeClass("filters__tags--active");
    $(".filters__activetags__tags").html("");
    // Uncheck all inputs
    $(".filters input").prop("checked", false);
    // Trigger filter
    filters__filter_posts(true);
  });
}

function filters__mobile() {
  const filtersHeadings = document.querySelectorAll(".filters__fieldset__heading");

  filtersHeadings.forEach(function (filtersHeading) {
    filtersHeading.addEventListener("click", function (e) {
      for (var n = 0; n < filtersHeadings.length; ++n) {
        if (filtersHeadings[n] !== this) {
          let all = filtersHeadings[n].closest(".filters__fieldset");
          all.classList.remove("filters__fieldset--open");
        }
      }
      const filterFieldset = this.closest(".filters__fieldset");
      filterFieldset.classList.toggle("filters__fieldset--open");
    });
    window.addEventListener("click", function (e) {
      if (filtersHeading.contains(e.target)) {
      } else {
        const filterFieldset = filtersHeading.closest(".filters__fieldset");
        filterFieldset.classList.remove("filters__fieldset--open");
      }
    });
  });

  const filtersFields = document.querySelectorAll(".filters__fieldset__field");

  filtersFields.forEach(function (filtersField) {
    filtersField.addEventListener("click", function (e) {
      const filterFieldset = this.closest(".filters__fieldset");
      filterFieldset.classList.remove("filters__fieldset--open");
    });
  });
}
